import * as React from 'react';

const icon: Record<string, string> = {
    'succeeded': 'fa-thumbs-up',
    'failed': 'fa-thumbs-down',
    'pending': 'fa-hourglass'
};

const color: Record<string, string> = {
    'succeeded': 'green',
    'failed': 'red',
    'pending': 'orange'
};

const EventStatusIcon: React.FC<{status: string}> = (props) => {
    return (
        <i
            className={`fal ${icon[props.status]}`}
            style={{
                color: `${color[props.status]}`
            }}
        />
    );
};

export default EventStatusIcon;